module.exports = __webpack_public_path__ + "img/7-low.6fecb11c.jpg";